module.exports = __webpack_public_path__ + "assets/b53.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b53.png
// module id = 642
// module chunks = 0